module.exports = __webpack_public_path__ + "static/logo-ihk-darmstadt-png-data-01cf75ca8562db76217239a5f5acccc4.svg";